<template>
  <v-table class="table_variant_surcharge">
    <thead>
      <tr>
        <th
          class="text-left"
          colspan="5">
          {{
            $t(
              "components.Calculations.Variants.ViewParts.SurchargeCashSalePriceTab.SiteSpecificSurcharges"
            )
          }}
        </th>
      </tr>
    </thead>
    <tbody class="low-height">
      <tr>
        <td class="wide_col">
          {{
            $t("entities.variant.fields.administrative_and_sales_costs_part")
          }}
        </td>
        <td class="input_col">
          <CalcOutput
            :id="locationId"
            field="administrative_and_sales_overhead_surcharge_percentage_location"
            hide-label />
        </td>
        <td class="perc_col">%</td>
        <td class="input_col">
          <CalcOutput
            :id="partId"
            field="administrative_and_sales_costs_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col">
          {{
            $t("entities.variant.fields.research_and_development_costs_part")
          }}
        </td>
        <td class="input_col">
          <CalcOutput
            :id="locationId"
            field="research_and_development_overhead_surcharge_percentage_location"
            hide-label />
        </td>
        <td class="perc_col">%</td>
        <td class="input_col">
          <CalcOutput
            :id="partId"
            field="research_and_development_costs_part"
            element-type="variant"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col">
          {{ $t("entities.variant.fields.calculated_venture_costs_part") }}
        </td>
        <td class="input_col">
          <CalcOutput
            :id="locationId"
            field="calculated_venture_costs_surcharge_percentage_location"
            hide-label />
        </td>
        <td class="perc_col">%</td>
        <td class="input_col">
          <CalcOutput
            :id="partId"
            field="calculated_venture_costs_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col">
          {{
            $t(
              "entities.variant.fields.flat_rate_surcharge_after_production_costs_part"
            )
          }}
        </td>
        <td class="input_col">
          <CalcOutput
            :id="locationId"
            field="flat_rate_surcharge_percentage_location"
            hide-label />
        </td>
        <td class="perc_col">%</td>
        <td class="input_col">
          <CalcOutput
            :id="partId"
            field="flat_rate_surcharge_after_production_costs_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td
          class="wide_col"
          colspan="3">
          {{
            $t(
              "entities.variant.fields.location_specific_surcharges_after_production_costs_part"
            )
          }}
        </td>
        <td class="input_col">
          <CalcOutput
            :id="partId"
            field="location_specific_surcharges_after_production_costs_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script setup>
import CalcOutput from "../../../../../components/Elements/CalcOutput.vue";

defineProps({
  partId: {
    type: String,
    required: true
  },
  locationId: {
    type: String,
    required: true
  }
});
</script>
